import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appMatSelectTyping]'
})
export class MatSelectTypingDirective {
  @Output() appMatSelectTyping = new EventEmitter<string>();
  
  private readonly typingDelay = 300; // Delay for debounce
  private unsubscribeAll = new Subject<void>();

  constructor(private matSelect: MatSelect, private elementRef: ElementRef) {
    // Listen to the `openedChange` event of `mat-select`
    this.matSelect.openedChange
      .pipe(
        takeUntil(this.unsubscribeAll)
      )
      .subscribe(isOpened => {
        if (isOpened) {
          // Set up event listener when dropdown is opened
          this.setupTypingListener();
        } else {
          // Clean up when dropdown is closed
          this.cleanupTypingListener();
        }
      });
  }

  private setupTypingListener() {
    fromEvent(this.matSelect.panel.nativeElement, 'input')
      .pipe(
        debounceTime(this.typingDelay),
        map(() => (this.matSelect.panel.nativeElement.querySelector('input') as HTMLInputElement).value)
      )
      .subscribe((value: string) => {
        console.log('User is typing:', value); // Log the current input value
        this.appMatSelectTyping.emit(value);
      });
  }
  private cleanupTypingListener() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
